import { Component, OnInit, Injectable, inject } from '@angular/core';
import { UserService } from '../../services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserRolesService } from '../../services/user-roles.service';
import Swal from 'sweetalert2';
import { Sign } from 'crypto';
import { DigitalSignatureService } from '../../services/digital-signatures.service';


@Component({
  selector: 'app-personal-profile',
  templateUrl: './personal-profile.component.html',
  styleUrl: './personal-profile.component.scss'
})
export class PersonalProfileComponent implements OnInit {
  activeTab: string = 'tab1';
  userId: string = '';
  userRole: string = '';
  userRoles:any[]=[]
  selectedRole:any;
  selectedFile: File | null = null;
  signatureUrl: string | null = null;
  signatureId: string | null = null;
  private userService= inject(UserService);
  private userRoleService=inject(UserRolesService)
  private digitalSignatureService=inject(DigitalSignatureService)

  showPassword: boolean = false;

  profileForm = new FormGroup({
    rut: new FormControl({ value: '', disabled: false }, [Validators.required]),
    employee_code: new FormControl({ value: '', disabled: false }),
    missionary_license: new FormControl({ value: '', disabled: false }),
    name: new FormControl({ value: '', disabled: false }, [Validators.required]),
    email: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.email]),
    password: new FormControl({ value: '', disabled: false }),
    user_role:  new FormControl([Validators.required])
  });

  ngOnInit(): void {
    //verificar el rol del usuario
    this.userService.selectedUserId$.subscribe(usr => {
      if(usr){
        this.userId = usr;
        this.getUserById();
      }
    });

    //verificar el rol del usuario
    this.userService.userRole$.subscribe(role => {
      this.userRole = role;
      if(this.userRole === 'Administrador'){
        this.loadUserRoles();
      }else{
        this.profileForm.get('user_role')?.disable();
      }
    });

  }

  loadSignature(): void {
    this.digitalSignatureService.getByUserId(this.userId).subscribe({
      next: (res) => {
        this.signatureUrl = res?.signature?.signedUrl || null;
        this.signatureId = res?.signature?._id || null;
      },
      error: (err) => {
        console.error('Error al cargar firma digital:', err);
      }
    });
  }

  loadUserRoles(): void {
    this.userRoleService.get().subscribe({
      next: (data) => {
        this.userRoles = data;
      },
      error: (err) => console.error('Error al obtener roles de usuario:', err)
    });
  }

  getUserById():void{
    this.userService.getById(this.userId).subscribe({
      next: (data) => {
        this.profileForm.patchValue(data);// Carga los datos en el formulario
        this.loadSignature();
      },
      error: (err) => {
        console.error('Error al obtener roles de usuario:', err);
      }
    });
  }

/*   toggleEdit(): void {
    this.isEditable = !this.isEditable;
    if (this.isEditable) {
      this.profileForm.enable(); 
    } else {
      this.profileForm.disable(); 
    }
  } */

  saveProfile(): void {
    if (this.profileForm.valid) {
      Swal.fire({
        title: 'Guardando Datos...',
        html: 'Por favor espera un momento.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      this.userService.update(this.userId, this.profileForm.value).subscribe({
        next: (response) => {
          if(response ){
            Swal.close();
            Swal.fire({
              icon: 'success',
              title: 'Edición finalizada',
              text: 'Cambios Guardados.'
            });
          }else{
            Swal.close();
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'No se han podido guardar los cambios.'
            });
          }
        
        },
        error: (err) => {console.error('Error al actualizar perfil:', err),Swal.close();Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se han podido guardar los cambios.'
        })},
      });
    }
  }

  changeTab(tabId: string): void {
    this.activeTab = tabId;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    } else {
      this.selectedFile = null;
    }
  }
  uploadSignature() {
    const formData = this.buildFormData();
    if (!formData) return;

    Swal.fire({
      title: 'Subiendo firma...',
      html: 'Por favor espera.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const request = this.signatureId
      ? this.digitalSignatureService.update(this.signatureId, formData)
      : this.digitalSignatureService.save(formData);

    request.subscribe({
      next: (response) => {
        Swal.close();
        console.log('Respuesta de la API:', response);
        if (response?.ExpenseAttachment?._id) {
          this.signatureUrl = response.ExpenseAttachment.signedUrl;
          this.signatureId = response.ExpenseAttachment.signature_id;
          Swal.fire({
            icon: 'success',
            title: 'Firma digital guardada',
            text: 'La firma digital ha sido guardada correctamente.'
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'No se ha podido guardar la firma digital.'
          });
        }
      },
      error: (err) => {
        console.error('Error al guardar firma digital:', err);
        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se ha podido guardar la firma digital.'
        });
      }
    });
  }

  saveSignature(): void {
   
  }

  updateSignature(): void {
    const formData = this.buildFormData();
    if (!formData || !this.signatureId) return;

    Swal.fire({
      title: 'Actualizando firma...',
      html: 'Por favor espera.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    this.digitalSignatureService.update(this.signatureId, formData).subscribe({
      next: (response) => {
        Swal.close();
        if (response?.signature?.signedUrl) {
          this.signatureUrl = response.signature.signedUrl;
          this.signatureId = response.signature._id;
          Swal.fire('Éxito', 'La firma digital ha sido actualizada correctamente.', 'success');
        } else {
          Swal.fire('Error', 'No se ha podido actualizar la firma digital.', 'error');
        }
      },
      error: (err) => {
        console.error('Error al actualizar firma digital:', err);
        Swal.close();
        Swal.fire('Error', 'No se ha podido actualizar la firma digital.', 'error');
      }
    });
  }

  private buildFormData(): FormData | null {
    if (!this.selectedFile) {
      Swal.fire('Error', 'Debe seleccionar un archivo antes de subir.', 'error');
      return null;
    }

    const allowedTypes = ['image/png', 'image/jpeg'];
    const maxSize = 2 * 1024 * 1024; // 2MB

    if (!allowedTypes.includes(this.selectedFile.type)) {
      Swal.fire('Error', 'Solo se permiten archivos JPG o PNG.', 'error');
      return null;
    }

    if (this.selectedFile.size > maxSize) {
      Swal.fire('Error', 'El archivo no debe superar los 2MB.', 'error');
      return null;
    }

    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('userId', this.userId);
    return formData;
  }

  deleteSignature(): void {
    if (!this.signatureId) return;

    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción eliminará tu firma digital actual.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Eliminando...',
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading()
        });

        this.digitalSignatureService.delete(this.signatureId!).subscribe({
          next: () => {
            Swal.close();
            this.signatureId = null;
            this.signatureUrl = null;
            this.selectedFile = null;
            Swal.fire('Eliminado', 'Tu firma digital ha sido eliminada.', 'success');
          },
          error: (err) => {
            console.error('Error al eliminar firma digital:', err);
            Swal.close();
            Swal.fire('Error', 'No se pudo eliminar la firma digital.', 'error');
          }
        });
      }
    });
  }


}
